import { FC } from 'react';
import EntitiesSearch from '../../EntitiesSearch';
import { PopupStateProps } from '@silverfort/sf-components';

import { EntitiesSearchProps } from '../../EntitiesSearch/EntitiesSearch';
import { Entity } from '../../../../../api';
import { EnrollmentEmailFormValues } from '../../../types/forms';

type State = Omit<EntitiesSearchProps, 'onSelectedEntitiesChange'> & { formValues?: EnrollmentEmailFormValues };

type Props = PopupStateProps<State>;

const EMPTY_STATE_PROPS: EntitiesSearchProps['emptyStateProps'] = {
    title: 'Add users',
    description: 'Search and select users to enroll'
};

const EntitiesSearchPopupContent: FC<Props> = ({ popupState, setPopupState }) => {
    const { selectedEntities } = popupState;

    const onSelectedEntitiesChange = (entities: Entity[]) => {
        setPopupState((prev) => ({ ...prev, selectedEntities: entities }));
    };

    return (
        <EntitiesSearch
            selectedEntities={selectedEntities}
            onSelectedEntitiesChange={onSelectedEntitiesChange}
            enableSelectAll={true}
            enableClearAll={true}
            showCheckboxes={true}
            emptyStateProps={EMPTY_STATE_PROPS}
        />
    );
};

export default EntitiesSearchPopupContent;
